import { render, staticRenderFns } from "./FullViewEdit.vue?vue&type=template&id=01805ff8&"
import script from "./FullViewEdit.vue?vue&type=script&lang=ts&"
export * from "./FullViewEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VFadeTransition,VMain,VNavigationDrawer,VThemeProvider})
